import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function ErrorState() {
  return (
    <div className={cx('error')}>
      <span className={cx('txt')}>
        서비스가 불안정합니다.
        <br />
        잠시 후 다시 접속 바랍니다.
        <br />
        이용에 불편을 드려 죄송합니다.
      </span>
    </div>
  );
}
